export const FontFamily = {
  base: "'Avenir', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
} as const;

export type FontFamilyTokenType = keyof typeof FontFamily;

export const FontSize = {
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '18px',
  xl: '20px',
  xxl: '24px',
  xxxl: '28px',
  '4xl': '30px',
} as const;

export type FontSizeTokenType = keyof typeof FontSize;

export const FontWeight = {
  light: 300,
  medium: 500,
  bold: 600,
} as const;

export type FontWeightTokenType = keyof typeof FontWeight;

export const LineHeight = {
  xs: '16px',
  sm: '20px',
  md: '22px',
  lg: '24px',
  xl: '28px',
  xxl: '32px',
  xxxl: '40px',
} as const;

export type LineHeightTokenType = keyof typeof LineHeight;
